module.exports = __webpack_public_path__ + "048b4ea473e4826337739cb310d456d4.png";